module.exports = __webpack_public_path__ + "img/banner6.656cd5b.svg";